module.exports = __webpack_public_path__ + "img/hupo.006b5bbc.svg";